import { LeftCircleFilled } from '@ant-design/icons'
import { Button } from 'uikit/buttons/default'
import { cn } from 'utils/classnames'
import styles from './side-panel.module.scss'

export interface SidePanelProps {
  children: React.ReactNode
  isOpen: boolean
  onToggle: () => void
  onClose?: () => void
  width?: number
  className?: string
}

/**
 * A collapsible side panel component for graph views.
 * Chevron toggles open/closed. Close button triggers onClose (or onToggle as fallback).
 */
export function SidePanel({ children, isOpen, onToggle, onClose, width = 310, className }: SidePanelProps) {
  return (
    <div className={cn(styles.wrapper, className)} style={{ width: isOpen ? width : 24 }}>
      {isOpen ? (
        <div className={styles.panelContent} style={{ width }}>
          {children}
          <div className={styles.panelFooter}>
            <Button type='primary' onClick={onToggle} className={styles.closeButton}>
              Close
            </Button>
          </div>
        </div>
      ) : (
        <div className={styles.panelCollapsed} />
      )}

      <Button
        type='text'
        icon={<LeftCircleFilled style={{ fontSize: '20px' }} />}
        size='small'
        onClick={onToggle}
        shape='circle'
        className={cn(styles.toggleButton, isOpen && styles.toggleOpen)}
        aria-label='Toggle panel'
      />
    </div>
  )
}
